/* ==========================================================================
   Sri Anu Jewellers — Menaxi (silver) page flag.   "Website Revamp Changes" #1

   The header only switches to the silver menu on the Menaxi landing template,
   so every collection reached FROM the Menaxi menu fell back to the Sri Anu
   gold menu. sections/saj-header.liquid is 50 KB and cannot be pushed through
   the Admin API, so the flag is set here instead.

   This file is loaded WITHOUT defer, before saj-fixes.js / saj-fix3-6.js, so
   by the time those run the page already looks like a Menaxi page to them and
   their existing machinery does the rest:
     · saj-fixes.js  swapMenaxiNav()  lifts the silver nav off /pages/menaxi
     · saj-fix4.js   menaxiMega() / menaxiAllCat() / menaxiDrawer()
   Nothing here needs to change when saj-header.liquid is eventually updated —
   it only ever ADDS the class the Liquid would have added itself.

   Two kinds of collection:
     HARD   — silver only. Always switches, however the shopper arrived.
     shared — necklace/earring/bangle edits that hang off BOTH the gold Bridal
              menu and the Menaxi menu (antique-necklace, necklace-sets, …).
              These follow the journey: silver if the shopper came through the
              Menaxi world, gold if they came in through a gold page. The
              journey is remembered for the tab in sessionStorage.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__sajMxFlag) return;
  window.__sajMxFlag = 1;

  var de = document.documentElement;
  var KEY = 'sajMxJourney';

  /* Collections that only ever exist in the silver world. */
  var HARD = ('silver menaxi exclusive-silver-collection silver-jewellery silver-utensils ' +
    'pooja-items haram-and-necklaces statement-silver-earrings anklets bangles chains ' +
    'bracelet toe-ring mugappu-chain more-collections other-collections ' +
    'traditional-anklet antique-anklets fancy-anklets rose-gold-anklets baby-anklets ' +
    'nagas-bangles antique-bangles swarovski-bangles baby-bangles other-bangle-collections ' +
    'nagas-earrings antique-earrings swarovski-earrings fancy-earrings traditional-earrings ' +
    'rings pendant vel-kappus silver-nose-pin silver-malai silver-coin silver-idols ' +
    'silver-keychain kumkum-box sandhana-pela frame').split(' ');

  /* Unmistakably gold/diamond ground — ends a silver journey. */
  var GOLD = /^\/collections\/(?:gold|diamond|custom-|most-gifted|lightweight-gold-jewelry-chain|more-gold-collections|yellow-gold|nakshi-antique|under-)/;

  function flag(on) {
    try {
      if (on) sessionStorage.setItem(KEY, '1');
      else sessionStorage.removeItem(KEY);
    } catch (e) { /* private mode — fall back to per-page detection */ }
  }
  function flagged() {
    try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }

  function silver() { de.classList.add('saj-menaxi-page'); flag(true); }

  var path = (location.pathname || '').toLowerCase().replace(/\/+$/, '') || '/';

  // The Liquid already decided on the landing template — just remember it.
  if (de.classList.contains('saj-menaxi-page')) { flag(true); return; }

  if (path === '/pages/menaxi' || path === '/pages/silver') { silver(); return; }

  var m = /^\/collections\/([^\/?#]+)/.exec(path);
  if (m) {
    if (HARD.indexOf(m[1]) !== -1) { silver(); return; }
    if (GOLD.test(path)) { flag(false); return; }
    if (flagged()) { silver(); }        // shared edit, reached from the silver side
    return;
  }

  // The gold home page is the clearest "I'm back in the gold world" signal.
  if (path === '/') flag(false);
})();
